import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { AttoDTO } from "../dto/atto-DTO";
import { AttoVO } from "../vo/attoVO";
import { MapperSettore } from "./mapper-settore";
import { MapperUtente } from "./mapper-utente";
import { MapperDocumento } from "./mapper-documento";
import { MapperVisibilitaAtto } from "./mapper-visibilita-atto";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";
import { MapperDatiContabili } from "./mapper-dati-contabili";

@Injectable({ providedIn: "root" })
export class MapperAtto
  implements MapperInterface<AttoDTO, AttoVO> {
  constructor(
    private settoreMapper: MapperSettore,
    private utenteMapper: MapperUtente,
    private documentoMapper: MapperDocumento,
    private visilitaMapper: MapperVisibilitaAtto,
    private metadatiRepertorioMapper: MapperMetadatiRepertorio,
    private datiContabiliMapper: MapperDatiContabili
  ) { }

  convertVoToDto(attoVO: AttoVO): AttoDTO {
    if (attoVO != null) {
      // console.log("[MapperSettore] attoVO => attoDTO", attoVO);
      const attoDTO = new AttoDTO();

      attoDTO.nome = attoVO.nome;
      attoDTO.id = attoVO.id;
      attoDTO.descrizione = attoVO.descrizione;
      attoDTO.dataConclusione = attoVO.dataConclusione;
      attoDTO.dataInserimento = attoVO.dataInserimento;
      attoDTO.dataUltimaModifica = attoVO.dataUltimaModifica;
      attoDTO.oggetto = attoVO.oggetto;
      attoDTO.tipo = attoVO.tipo;
      attoDTO.pubblicabile = attoVO.pubblicabile;
      attoDTO.allegati = this.documentoMapper.convertListVoToDto(attoVO.allegati);
      attoDTO.settore = this.settoreMapper.convertVoToDto(
        attoVO.settore
      );
      attoDTO.responsabile = this.utenteMapper.convertVoToDto(
        attoVO.responsabile
      );
      attoDTO.tipologiaDecreto = attoVO.tipologiaDecreto;
      attoDTO.redattore = this.utenteMapper.convertVoToDto(
        attoVO.redattore
      );
      attoDTO.contenutoAtto =
        attoVO.contenutoAtto;
      attoDTO.datiContabili = this.datiContabiliMapper.convertListVoToDto(attoVO.datiContabili);

      attoDTO.ordinario = attoVO.ordinario;
      attoDTO.progressivo = attoVO.progressivo;
      attoDTO.riservato = attoVO.riservato;
      attoDTO.relazioneVerificatore = this.documentoMapper.convertVoToDto(attoVO.relazioneVerificatore);

      attoDTO.rimandato = attoVO.rimandato;
      // console.log("return", attoDTO);
      return attoDTO || new AttoDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(attoDTO: AttoDTO): AttoVO {
    if (attoDTO != null) {
      // console.log("[MapperSettore] attoVO => attoDTO", attoVO);
      const attoVO = new AttoVO();

      attoVO.nome = attoDTO.nome;
      attoVO.id = attoDTO.id;
      attoVO.descrizione = attoDTO.descrizione;
      attoVO.dataConclusione = attoDTO.dataConclusione;
      attoVO.dataInserimento = attoDTO.dataInserimento;
      attoVO.dataUltimaModifica = attoDTO.dataUltimaModifica;
      attoVO.stato = attoDTO.stato;
      attoVO.oggetto = attoDTO.oggetto;
      attoVO.tipo = attoDTO.tipo;
      attoVO.tipologiaDecreto = attoDTO.tipologiaDecreto;
      attoVO.primario = this.documentoMapper.convertDtoToVo(attoDTO.primario);
      attoVO.visibilitaAtto = this.visilitaMapper.convertListDtoToVo(attoDTO.visibilitaAtto);
      attoVO.allegati = this.documentoMapper.convertListDtoToVo(attoDTO.allegati);
      attoVO.riservato = attoDTO.riservato;
      attoVO.settore = this.settoreMapper.convertDtoToVo(
        attoDTO.settore
      );
      attoVO.responsabile = this.utenteMapper.convertDtoToVo(
        attoDTO.responsabile
      );
      attoVO.redattore = this.utenteMapper.convertDtoToVo(
        attoDTO.redattore
      );
      attoVO.contenutoAtto =
        attoDTO.contenutoAtto;
      attoVO.progressivo = attoDTO.progressivo;
      attoVO.datiContabili = this.datiContabiliMapper.convertListDtoToVo(attoDTO.datiContabili);
      attoVO.pubblicabile = attoDTO.pubblicabile;
      attoVO.motivoStato = attoDTO.motivoStato;
      attoVO.ordinario = attoDTO.ordinario;
      attoVO.metadatiRepertorio = this.metadatiRepertorioMapper.convertDtoToVo(attoDTO.metadatiRepertorio);
      attoVO.relazioneVerificatore = this.documentoMapper.convertDtoToVo(attoDTO.relazioneVerificatore);
      attoVO.rimandato = attoDTO.rimandato;
      // console.log("return", attoDTO);
      return attoVO || new AttoVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(attoVOList: AttoVO[]): AttoDTO[] {
    // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

    const attoDTOList = new Array<AttoDTO>();
    attoVOList.forEach((vo) => {
      attoDTOList.push(this.convertVoToDto(vo));
    });

    return attoDTOList || new Array<AttoDTO>();
  }

  convertListDtoToVo(attoDTOList: AttoDTO[]): AttoVO[] {
    // console.log("[MapperSettori] attoDTOList => attoDTOList");
    // console.log("attoDTOList", attoDTOList);
    const attoVOList = new Array<AttoVO>();
    attoDTOList.forEach((dto) => {
      attoVOList.push(this.convertDtoToVo(dto));
    });

    return attoVOList || new Array<AttoVO>();
  }
}
